import { render } from "./configModal.vue?vue&type=template&id=a3418cea&scoped=true"
import script from "./configModal.vue?vue&type=script&lang=js"
export * from "./configModal.vue?vue&type=script&lang=js"

import "./configModal.vue?vue&type=style&index=0&id=a3418cea&scoped=true&lang=scss"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3418cea"]])

export default __exports__